import type { TourStepData } from './types';

export const salesIntelligenceTourSteps: TourStepData[] = [
  {
    target: '[data-tour="sales-intelligence-header"]',
    title: 'Sales Intelligence',
    content:
      'Le module Sales Intelligence (Intelligence commerciale) regroupe 3 outils IA pour preparer vos rendez-vous et prospecter efficacement.',
    placement: 'bottom',
    glossaryTerm: 'sales-intelligence',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-3',
    title: 'Metriques commerciales',
    content:
      'Visualisez le nombre de Battle Cards generees, d\'emails de prospection envoyes et de profils prospects analyses.',
    placement: 'bottom',
    glossaryTerm: 'battle-cards',
  },
  {
    target: '.fc-card .flex.border-b',
    title: 'Onglets outils',
    content:
      'Basculez entre Battle Card (Fiches argumentaires), Cold Outreach (Prospection a froid) et Prospect Profiler pour acceder a chaque outil.',
    placement: 'bottom',
    glossaryTerm: 'cold-outreach',
  },
];
